import { render, staticRenderFns } from "./vRecipeNutritionLabelPrintout.vue?vue&type=template&id=50966bea&scoped=true"
import script from "./vRecipeNutritionLabelPrintout.vue?vue&type=script&setup=true&lang=ts"
export * from "./vRecipeNutritionLabelPrintout.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./vRecipeNutritionLabelPrintout.vue?vue&type=style&index=0&id=50966bea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50966bea",
  null
  
)

export default component.exports